// eslint-disable
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_ENV === 'fat' ? '/evaluate/' : '/v2',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: () => import('./views/Index.vue')
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('./views/success.vue')
    }
  ]
});

export default router;
